import { FC } from 'react'

import { B2bFormButton } from '@/screens/B2b/page/ui/B2bFormButton/B2bFormButton'
import { CatalogMain } from '@/screens/CatalogMain'
import { SectionTradeIn } from '@/screens/services-trade-in/page/ui/section-trade-in/section-trade-in'

import { HeroInfoBlock } from '@/widgets/HeroInfoBlock'
import { VerticalSteps } from '@/widgets/VerticalSteps'

import { CatalogItem } from '@/entities/catalog/types'

import { AdvLine } from '@/shared/ui/AdvLine/AdvLine'
import { FaqSection } from '@/shared/ui/FaqSection'
import Flex from '@/shared/ui/Flex'
import { HorizontalSection } from '@/shared/ui/HorizontalSection'
import { PdfList } from '@/shared/ui/PdfList'

import { AdvLineData, faqItemsUr, heroInfoDataUr, pdfListUr, stepsItemsUr } from './data'

import styles from './styles.module.scss'

type B2bTradeInProps = {
	catalogItems: CatalogItem[]
}

export const B2bTradeIn: FC<B2bTradeInProps> = ({ catalogItems }) => {
	return (
		<div className={styles.tradeIn}>
			<HeroInfoBlock
				tabItems={[
					{
						title: `Физическое лицо`,
						link: `/services/trade-in/`,
						isActive: false
					},
					{ title: `Юридическое лицо`, link: `/b2b/trade-in/`, isActive: true }
				]}
				{...heroInfoDataUr}
				customButton={<B2bFormButton big>Оставить заявку</B2bFormButton>}
			/>

			<HorizontalSection title="Как это работает?">
				<div className={styles.tradeInVerticalSteps}>
					<VerticalSteps items={stepsItemsUr} />
				</div>
			</HorizontalSection>

			<Flex className={styles.tradeInFlex} justifyCenter alignCenter>
				<B2bFormButton big>Оставить заявку</B2bFormButton>
			</Flex>

			<SectionTradeIn />

			<CatalogMain catalogItems={catalogItems} />

			<HorizontalSection title="Частые вопросы">
				<FaqSection items={faqItemsUr} />
			</HorizontalSection>

			<PdfList items={pdfListUr} />

			<AdvLine {...AdvLineData} />
		</div>
	)
}
